// The availability control both account holders use: a permit holder marking
// the weekdays they won't need their spot, a parker marking the weekdays they
// need one.
//
// Tap a day, and that is the whole interaction — a tapped day is the **whole
// day** until you say otherwise. Only then does that day offer "Set hours", and
// its two time fields start **empty**: a prefilled 7:30–12:00 is a guess about
// someone's timetable, and one left unchanged publishes hours they never chose.
// The store refuses a half-filled window for the same reason.

import { DAYS, dayLong, sortSlots } from './schedule';

export default function WeekdayPicker({ value = [], onChange }) {
  const byDay = new Map(value.map(s => [s.day, s]));
  const commit = (next) => onChange(sortSlots(next));

  const toggle = (day) => {
    if (byDay.has(day)) commit(value.filter(s => s.day !== day));
    else commit([...value, { day, allDay: true, start: '', end: '' }]);
  };

  const patch = (day, next) => commit(value.map(s => (s.day === day ? { ...s, ...next } : s)));

  return (
    <div>
      <div className="pc-week">
        {DAYS.map(({ day, letter, long }) => (
          <button
            type="button" key={day} onClick={() => toggle(day)}
            className={`pc-wday ${byDay.has(day) ? 'on' : ''}`}
            aria-pressed={byDay.has(day)} aria-label={long} title={long}
          >
            {letter}
          </button>
        ))}
      </div>

      {value.length > 0 && (
        <div className="pc-slots">
          {sortSlots(value).map(slot => (
            <div className="pc-slot" key={slot.day}>
              <span className="pc-slot-day">{dayLong(slot.day)}</span>
              <div className="pc-toggle sm">
                <button
                  type="button" className={slot.allDay ? 'on' : ''}
                  onClick={() => patch(slot.day, { allDay: true, start: '', end: '' })}
                >
                  All day
                </button>
                <button
                  type="button" className={slot.allDay ? '' : 'on'}
                  onClick={() => patch(slot.day, { allDay: false })}
                >
                  Set hours
                </button>
              </div>
              {!slot.allDay && (
                <span className="pc-times">
                  <input
                    type="time" className="pc-time" value={slot.start || ''}
                    onChange={e => patch(slot.day, { start: e.target.value })}
                    aria-label={`Start time on ${dayLong(slot.day)}`}
                  />
                  <span className="pc-small">to</span>
                  <input
                    type="time" className="pc-time" value={slot.end || ''}
                    onChange={e => patch(slot.day, { end: e.target.value })}
                    aria-label={`End time on ${dayLong(slot.day)}`}
                  />
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
